<template>
  <v-app>
    <vertical-nav-menu :is-drawer-open.sync="isDrawerOpen"></vertical-nav-menu>

    <v-app-bar
      app
      flat
      absolute
      class="mobile-fixed-bar" 
    >
      <div class="boxed-container w-full">
        <div class="d-flex align-center mx-6">
          <!-- Left Content -->
          <v-app-bar-nav-icon
            class="d-block d-lg-none me-2"
            @click="isDrawerOpen = !isDrawerOpen"
          ></v-app-bar-nav-icon>
          <!-- <v-text-field
            rounded
            dense
            outlined
            :prepend-inner-icon="icons.mdiMagnify"
            class="app-bar-search flex-grow-0"
            hide-details
          ></v-text-field> -->

          <v-spacer></v-spacer>

          <!-- Right Content -->

          <!--變色 <theme-switcher></theme-switcher> -->
          <v-btn
            icon
            small
            class="ms-3"
            @click="subscribePush"
          >
            <v-icon>
             {{ icons.mdiBellOutline }}
            </v-icon>
          </v-btn>

          <v-btn
            icon
            small
            class="ms-3"
            @click="triggerTour"
          >
            <v-icon>
             {{ icons.mdiCogOutline }}
            </v-icon>
          </v-btn>

          

          <v-btn
            icon
            small
            class="ms-3"
            @click="logout"
          >
            <v-icon>
             {{ icons.mdiLogoutVariant }}
            </v-icon>
          </v-btn>
          <app-bar-user-menu></app-bar-user-menu>
        </div>
      </div>
    </v-app-bar>

    <v-main>
      <div class="app-content-container boxed-container pa-6">

        <slot></slot>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiMagnify, mdiBellOutline, mdiGithub, mdiLogoutVariant, mdiCogOutline } from '@mdi/js'
import VerticalNavMenu from './components/vertical-nav-menu/VerticalNavMenu.vue'
import ThemeSwitcher from './components/ThemeSwitcher.vue'
import AppBarUserMenu from './components/AppBarUserMenu.vue'
import router from '@/router/index'
import axios from '@/utils/axios'

export default {
  components: {
    VerticalNavMenu,
    ThemeSwitcher,
    AppBarUserMenu,
  },
  setup(props, context) {
    // 登出
    const isDrawerOpen = ref(null)
    const logout = () => {
      localStorage.removeItem('HTwater.token');
      localStorage.removeItem('setName');
      localStorage.removeItem('setDeptId');
      localStorage.removeItem('setPosition');
      localStorage.removeItem('setDeptName');
      localStorage.removeItem('setRoleId');
      localStorage.removeItem('setBranchesName');
      localStorage.removeItem('setErpDept');
　　　 localStorage.removeItem('show');
      
      router.push({
            name: 'pages-login'
          })
    }

    const triggerTour = () => {
      context.root.$store.dispatch('triggerTour');
  };

  const vapidPublicKey = 'BPUI6_lmNwHFeSj0iqLb1MXNCtHMCeUW4eHzuEdv9JhxHWEUcEijnxUdvGwq2TNlhrU_jj4am3SO544s8Tvgdnk';


function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  return new Uint8Array([...rawData].map(char => char.charCodeAt(0)))
}

function arrayBufferToBase64(buffer) {
  const bytes = new Uint8Array(buffer);
  let binary = '';
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}
  
const subscribePush = async () => {

  if (!('serviceWorker' in navigator)) {
    alert('此瀏覽器不支援 Service Worker');
    return;
  }
    const perm = await Notification.requestPermission();
  if (perm !== 'granted') return alert('請先允許通知，謝謝！');

  const registration = await navigator.serviceWorker.register('/sw.js');

  const existingSub = await registration.pushManager.getSubscription();

  if (existingSub) {
    await existingSub.unsubscribe();
     alert('已更新訂閱');
  }

  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidPublicKey)
  });

  // 4️⃣ 整理 payload
  const payload = {
    endpoint: subscription.endpoint,
    p256dh: arrayBufferToBase64(subscription.getKey('p256dh')),
    auth: arrayBufferToBase64(subscription.getKey('auth'))
  };

  // 5️⃣ 傳送訂閱資訊至後端
  try {
    await axios.post('push_subscribe', payload);

    // 6️⃣ 顯示通知測試
    registration.showNotification('🚀 訂閱成功！', {
      body: '推播內容會顯示在這裡💧',
      icon: '/HTlogo.svg'
    });
  } catch (error) {
    console.error('訂閱失敗:', error);
    alert('訂閱失敗，請洽資訊處');
  }
};



    return {
      isDrawerOpen,
      logout,
      triggerTour,
      subscribePush,
      icons: {
        mdiMagnify,
        mdiBellOutline,
        mdiGithub,
        mdiLogoutVariant,
        mdiCogOutline,
      },
    }
  },
}
</script>

<style lang="scss" scoped>
.v-app-bar ::v-deep {
  .v-toolbar__content {
    padding: 0;

    .app-bar-search {
      .v-input__slot {
        padding-left: 18px;
      }
    }
  }
}

.boxed-container {
  max-width: 1440px;
  margin-left: auto;
  margin-right: auto;
}

@media only screen and (max-width: 1200px) {
  .mobile-fixed-bar {
    position: fixed !important;
  }
}
</style>
